<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title2">I<span class="small">NTRODUCTION</span></p>
<p class="noindent">In this book you will come to know Florentine spirits and ghosts from all walks of life, from the most supernatural to the most human, from the most diabolical to the most divine, from the most joyful to the most disturbed, from the poorest to the wealthiest, from the most intelligent to the most foolish and everywhere in between. Their life stories also share the amazing collective story of what it means to be American and live in what has become the great and diverse nation of the United States of America from the very beginning as a vast landscape of rugged and treacherous wilderness to the modern high-tech age of the twenty-first century today. Whatever you may discover at the timeless crossroads of haunted Florence, you will be encouraged and inspired to want to learn even more about the fascinating history of the Magic City and also reconsider what it means to be a ghost…</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Introduction.vue?5450bb26